export default function elementScroll(ref, targetPosition = 50) {
  if (ref) {
    window.scrollTo(0, ref.offsetTop - targetPosition);
  }
}
